import StudentPlanReceivedComponent from './received.component';
import '../student.less';


export default angular
  .module('fizyweb.paycell.student.received', [])
  .component('received', StudentPlanReceivedComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/received/received.module.ts